"use client";
import React, { FC, ReactNode, useState } from "react";
import { useAppDispatch } from "../../../hooks/store-hooks";
import { closeModal } from "../../../store/slices/modalSlice";
import { Cross } from "../../../icons";

interface ModalProps {
  isOpen: boolean;
  onClose?: () => void;
  exitAnimation?: boolean;
  size?: "small" | "medium" | "large" | "full";
  children?: ReactNode;
  title?: string;
  closeOnOverlayClick?: boolean;
  animationDuration?: number;
  customClass?: string;
  parentCustomClass?: string;
  isShowHeader?: boolean;
  variant?: string;
  blurBg?: boolean;
  customVariant?: string;
  setModalOpen?: any;
}

// const sizes: { [key: string]: string } = {
//   small: "w-1/4",
//   medium: "w-1/2",
//   large: "w-3/4",
//   full: "w-full",
// };

const Modal: FC<ModalProps> = ({
  isOpen,
  exitAnimation = false,
  size = "large",
  children,
  title,
  closeOnOverlayClick = true,
  variant = "center",
  customClass = "",
  parentCustomClass = "",
  isShowHeader = false,
  blurBg = false,
  customVariant = "",
  setModalOpen,
}: any) => {
  const dispatch = useAppDispatch();
  const [closed, setClosed] = useState(false);
  const getSizeClassName = (customized?: string) => {
    switch (customized || size) {
      case "small":
        return "w-[440px]";
      case "medium":
        return "md:w-[550px] w-full";
      case "large":
        return "md:w-[660px] w-full";
      case "full":
        return "w-full";
      default:
    }
  };

  const getVariantClassName = () => {
    switch (variant) {
      case "center":
        return `top-0 left-0 right-0 mx-auto ${getSizeClassName()}`;
      case "right":
        return `right-0 h-screen !my-0 top-0 modal-right ${getSizeClassName(
          size || "medium",
        )}`;
      case "middle":
        return `top-[60%] left-1/2 transform -translate-x-1/2 -translate-y-3/4 ${getSizeClassName()}`;
      default:
    }
  };

  const handleClose = () => {
    setClosed(true);
    setTimeout(() => {
      if (setModalOpen) {
        setModalOpen(false);
      } else dispatch(closeModal());
    }, 233);
  };

  const handleOverlayClick = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
  ) => {
    if (closeOnOverlayClick && e.target === e.currentTarget) {
      handleClose();
    }
  };

  return (
    <>
      {isOpen && (
        <>
          <div
            className={`fixed h-screen flex items-center w-screen justify-center bg-black bg-opacity-30 ${blurBg ? "backdrop-blur-[2px]" : ""} z-30 left-0 ${parentCustomClass.includes("top") ? parentCustomClass : "top-0"}`}
            onClick={handleOverlayClick}
          ></div>
          <div>
            <div
              className={`fixed overflow-scroll ${customClass.includes("bg-") ? "" : "bg-white"} rounded-lg shadow-2xl text-black mx-auto my-20 z-40 ${closed || exitAnimation ? "modal-exit" : "modal-enter"} ${getVariantClassName()} ${customClass} ${customVariant}`}
              onClick={(e) => e.stopPropagation()}
            >
              {isShowHeader && (
                <div className="flex justify-between items-center mb-4 p-6">
                  <h2 className="text-xl font-bold">{title}</h2>
                  <button
                    onClick={handleClose}
                    className="text-gray-500 hover:text-gray-700"
                  >
                    <Cross />
                  </button>
                </div>
              )}
              {children}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Modal;
